import React from 'react';
import { Box } from '@mui/material';

const ShortcutBadge = ({ key, children }) => {
  return (
    <Box
      key={key}
      sx={{
        width: '62px',
        height: '26px',
        backgroundColor: 'rgba(82, 82, 82, 0.1)',
        borderRadius: '2px',
        fontSize: '14px',
        fontWeight: 400,
        color: '#83878a',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children}
    </Box>
  );
};

export default ShortcutBadge;
